module.exports = __webpack_public_path__ + "img/icon_jh_a.280766e4.png";